import { jsx } from 'react/jsx-runtime';
import { BaseTile } from '@vp/swan';
import { clsx } from '../../external/clsx/dist/clsx.js';
import { forwardRef } from 'react';
import styles from './template-tile.module.scss.js';

const TemplateTile = forwardRef((props, ref) => {
  const { className, children, ...rest } = props;
  const classNames = clsx(className, {
    [styles.templateTile]: true
    // DO NOT DELETE! At least one non-empty, imported CSS class is required per EP component.
  });
  return /* @__PURE__ */ jsx(BaseTile, { ref, className: classNames, p: "3", pb: "6", skin: "card", bgc: "strong", ...rest, children });
});

export { TemplateTile };
